import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styles: [`
    .bg-fondo { background-color: var(--beige-oscuro) !important; }
    .bg-fondo1 { background-color: var(--gris); }
    .bloque { padding: 20px 0; text-align: center; vertical-align: middle; line-height: normal; }
    .text1 { font-size: 1rem; }
    .text2 { font-size: .75rem; }
    fa-icon { color: var(--marron-oscuro); }
    .division { margin-top: .75rem; border-right: solid 1px var(--marron-oscuro); }
  `]
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
